import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IDevice } from 'interfaces';
import { formatDateShort, formatTime } from 'services/Utils';
import { ModalState, UserRole } from 'enums';
import { UserService } from 'services';

interface IDevicesItemProps {
    device: IDevice,
    isChecked: boolean,
    className: string,
    onShowDeleteModal: (d: IDevice[]) => void,
    onShowDeviceModal: (d: IDevice, state: ModalState) => void,
    onSelectDevice: (d: IDevice) => void,
}

export const DevicesItem: FunctionComponent<IDevicesItemProps> = ({ device, isChecked, className, onShowDeleteModal, onShowDeviceModal, onSelectDevice }) => {

    // info fields
    const serial = "Serial Number:";
    const location = "Location:";
    
    const serialTitle = serial + ' ' + device.serialNumber;
    const locationTitle = location + ' ' + device.location.number
    
    const lastSeenDate = formatDateShort(device.lastSeen);
    const lastSeenTime = formatTime(device.lastSeen);

    return (
        <li className={className} key={device.id}>
            <div className="devicesItem_checkCol devicesItem_col">
                <div className="devicesItem_checkCircle">
                    <input 
                        name={device.id + ''}
                        type="checkbox"
                        className="devicesItem_check" 
                        onChange={() => onSelectDevice(device)}
                        checked={isChecked}
                    />
                </div>
            </div>
            <Link to={'/devices'} onClick={() => onShowDeviceModal(device, ModalState.View)} className="devicesItem_modalLink">
                <div className="devicesItem_iconCol devicesItem_col">
                    <div className="devicesItem_iconCircle">
                        <FontAwesomeIcon icon="hdd" className="devicesItem_icon" />
                    </div>
                </div>
                <div className="devicesItem_makeModelCol devicesItem_col">
                    <div className="devicesItem_manufacturer ellipsis" title={device.manufacturer.name}>
                        {device.manufacturer.name}
                    </div>
                    <div className="devicesItem_model ellipsis" title={device.modelNumber}>
                        {device.modelNumber}
                    </div>
                </div>
                <div className="devicesItem_detailsCol devicesItem_col">
                    <div className="devicesItem_detailsLeft">
                        <div className="ellipsis" title={serialTitle}>
                            {serial}
                        </div>
                        <div className="ellipsis" title={locationTitle}>
                            {location}
                        </div>
                    </div>
                    <div className="devicesItem_detailsRight">
                        <div className="ellipsis" title={serialTitle}>
                            {device.serialNumber}
                        </div>
                        <div className="ellipsis" title={locationTitle}>
                            {device.location.number}
                        </div>
                    </div>
                </div>
                <div className="devicesItem_lastSeenCol devicesItem_col" title={lastSeenDate + ' ' + lastSeenTime}>
                    {lastSeenDate} <br/>
                    {lastSeenTime}
                </div>
            </Link>

            {UserService.oktaUserInfo.role >= UserRole.Admin && <>
            <Link to={'/devices'} onClick={() => onShowDeviceModal(device, ModalState.Edit)} className="devicesItem_editCol">
                <FontAwesomeIcon icon="edit" className="devicesItem_editIcon" />
            </Link>

            <Link to={'/devices'} onClick={() => onShowDeleteModal([device])} className="devicesItem_editCol" >
                <FontAwesomeIcon icon="trash" className="devicesItem_editIcon" />
            </Link></>}

        </li>
    );
}
